import { render, staticRenderFns } from "./coreReport.vue?vue&type=template&id=a0f40b16&scoped=true&"
import script from "./coreReport.vue?vue&type=script&lang=js&"
export * from "./coreReport.vue?vue&type=script&lang=js&"
import style0 from "./coreReport.vue?vue&type=style&index=0&id=a0f40b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f40b16",
  null
  
)

export default component.exports